import { useEffect } from "react";

/**
 * Tauscht das aktuelle `<link rel="icon">` gegen ein Routen-spezifisches SVG
 * aus. Beim Unmount stellt der Hook das vorherige Favicon wieder her, damit
 * der globale Default (Kanzlei-K) erhalten bleibt.
 */
export const useFavicon = (href) => {
  useEffect(() => {
    if (!href) return undefined;
    const link =
      document.querySelector('link[rel="icon"]') ||
      (() => {
        const el = document.createElement("link");
        el.rel = "icon";
        el.type = "image/svg+xml";
        document.head.appendChild(el);
        return el;
      })();
    const prev = link.getAttribute("href");
    link.setAttribute("href", href);
    return () => {
      if (prev) link.setAttribute("href", prev);
    };
  }, [href]);
};
